import React from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import {
    Popover,
    IconButton,
    Typography,
    Box,
    Switch,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
export function ConfigPopover({
    el,
    handleClose,
    handleRefresh,
    handleChangeAutoRefresh,
    autoRefresh,
}) {
    const { t } = useTranslation();
    return (
        <Popover
            anchorEl={el}
            onClose={handleClose}
            open={Boolean(el)}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
        >
            <IconButton
                color="primary"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#66788A",
                }}
                onClick={handleRefresh}
            >
                <RefreshIcon color="primary" style={{ color: "#66788A" }} />
                <Typography
                    variant="h4"
                    style={{
                        fontSize: "15px",
                        float: "right",
                        paddingLeft: "5px",
                        color: "#66788A",
                    }}
                >
                    {t('text.update')}
                </Typography>
            </IconButton>
            <Box display="flex" paddingRight={2}>
                <Switch
                    value={autoRefresh}
                    checked={autoRefresh}
                    onChange={handleChangeAutoRefresh}
                    color="primary"
                    style={{ margin: 0 }}
                />
                <Box>
                    <Typography
                        variant="h4"
                        style={{
                            fontSize: "15px",
                            paddingLeft: "5px",
                            color: "#66788A",
                            marginBottom: -5,
                        }}
                    >
                        {t('text.auto-refresh')}
                    </Typography>
                    <Typography
                        style={{
                            fontSize: "10px",
                            color: "#66788A",
                            paddingLeft: "5px",
                        }}
                    >
                        (5 mins.)
                    </Typography>
                </Box>
            </Box>
        </Popover>
    );
}
